module.exports = __webpack_public_path__ + "img/img24.cc441a88.png";